import { Box, Modal } from '@mui/material';
import { useState } from 'react';
import { AddBankComponent } from './AddBankComponent';
import { ApplyNewPayment } from './ApplyNewPayment';
import { ConfirmNewPayment } from './ConfirmPayment';
import { FooterModal } from './FooterModal';
import useStyles from './styles';

export const MainComponent = ({ openModal, closeModal }) => {
    const classes = useStyles();
    const [counter, setCounter] = useState(0);
    const [selected, setSelected] = useState(null);
    const [propertiesBanks, setProperties] = useState({
        identifier: '',
        password: '',
        banckName: ''
    });
    const [nodes, setBankNodes] = useState();
    const [node, setNode] = useState();
    const listOfComponents = [AddBankComponent, ConfirmNewPayment, ApplyNewPayment];
    const ComponenentInView = listOfComponents[counter];
    const incrementCounter = () => {
        if (counter < listOfComponents.length - 1) {
            return setCounter(counter + 1);
        }
        setCounter(0);
        setSelected(null);
        closeModal();
    };
    const reduceCounter = () => {
        return setCounter(counter - 1);
    };

    const getNodes = nodes => {
        setBankNodes(nodes);
    };

    const getNodeSelected = node => {
        setNode(node);
    };

    const onChangeInput = (name, value) => {
        setProperties({
            ...propertiesBanks,
            [name]: value
        });
    };

    const selectBank = ({ index, bankName }) => {
        setSelected(index);
    };

    return (
        <Modal open={openModal} onClose={closeModal}>
            <Box
                className={classes.modalComponent}
                style={{
                    width: counter > 0 && '300px'
                }}>
                <ComponenentInView
                    setCounter={incrementCounter}
                    reduceCounter={reduceCounter}
                    selectBank={selectBank}
                    selected={selected}
                    onChangeInput={onChangeInput}
                    propertiesBanks={propertiesBanks}
                    nodesBankInfo={getNodes}
                    nodesToList={nodes}
                    selectedNode={getNodeSelected}
                />
                <Box>
                    {counter === 0 && (
                        <FooterModal
                            closeModal={closeModal}
                            counter={counter}
                            setCounter={incrementCounter}
                            selected={selected}
                        />
                    )}
                </Box>
            </Box>
        </Modal>
    );
};
